import { Transition } from '@headlessui/react'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { ReactElement } from 'react'
import { classNames } from 'utils/dom-helpers'

export type AlertPromptProps = {
    title: string
    title_top_spacing?: number
    handlebars?: Record<string, string>
    body?: string | JSX.Element
    children?: ReactElement
    className?: string
    icon?:
    | 'alert-triangle bg-red-500'
    | 'check bg-green-500'
    | 'alert-triangle bg-yellow-500'
    | ReactElement
    logo?: ReactElement
    show: boolean
    actions: ReactElement<HTMLButtonElement>[]
    rem_width?: number
    window_class?: string
    title_class?: string
    message_class?: string
    onCloseAnimationFinish?(): void
}
export default function AlertPrompt({
    title,
    title_top_spacing,
    body,
    children,
    className,
    handlebars,
    icon,
    logo,
    show,
    rem_width,
    actions,
    window_class,
    title_class,
    message_class,
    onCloseAnimationFinish,
}: AlertPromptProps) {
    const {is_mobile} = useAppContext()
    return (
        <Transition
            show={show}
            enter="transition-opacity duration-300"
            enterFrom="opacity-0 -translate-y-full"
            enterTo="opacity-100 translate-y-0"
            leave="transition-opacity duration-300"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-full"
            as="div"
            className={classNames(className || "", is_mobile ? "relative w-screen" : "")}
            afterLeave={onCloseAnimationFinish}
        >
            <div
                className={classNames(`px-6 pb-8 pt-12 bg-white shadow-dialog rounded-lg text-center relative ${window_class || `lg:w-[${rem_width || 30}rem]`
                    }`, is_mobile ? "absolute w-full" : "mx-auto")}
            >
                {typeof icon == 'object'
                    ? icon
                    : !!icon && (
                        <i
                            className={`feather-${icon || 'alert-triangle bg-red-500'
                                } text-white rounded-full w-10 h-10 block mx-auto pt-1 text-lg`}
                        />
                    )}
                {logo}
                <h3
                    className={classNames(`text-2xl font-semibold text-primary mt-${title_top_spacing || 6
                        } mb-4 leading-none whitespace-pre-line`, title_class || "")}
                >
                    <Translation
                        content_key={title}
                        content_values={handlebars}
                    />
                </h3>

                {!(typeof body === 'object') ? (
                    <Translation
                        render_as="p"
                        content_key={body as string}
                        content_values={handlebars}
                        className={message_class}
                    />
                ) : (
                    body
                )}
                {children || ''}
                <div className="flex flex-row justify-center items-center mt-10 gap-4 booking-modal-btns">
                    {actions}
                </div>
            </div>
        </Transition>
    )
}
